import type React from 'react';

import { useHomepagePageData } from '#src/app/pages/homepage/pageContext';
import globeUrl from '#src/app/pages/homepage/shared/assets/background-globe-sunrise.svg';
import { TopImpactStoriesMobile, TopImpactStoriesMobileProvider } from '#src/app/pages/homepage/shared/components';

import { SapCtas } from './components/SapCtas';
import { TitleAndTagline } from './components/TitleAndTagline';
import { TopImpactStoriesDesktop } from './components/TopImpactStoriesDesktop';

export const HeroSection: React.FC = () => {
	const {
		data: { topImpactStories },
	} = useHomepagePageData();

	return (
		<section data-testid="homepage-hero-section" className="text-typography-strong relative overflow-hidden">
			<div
				aria-hidden="true"
				className="absolute aspect-video w-full max-w-[931px] translate-x-0 -translate-y-[20%] overflow-visible max-md:h-full md:top-[15%] md:left-1/2 md:-translate-x-1/2 md:-translate-y-[30%]"
			>
				{/* The old <img> combined object-cover with overflow-visible, letting the full
				    931x909 globe paint outside its 16:9 box. A div's mask cannot paint outside
				    its own box, so the cover-with-overflow rendering is reproduced by an inner
				    element at the SVG's aspect ratio spanning at least the outer box. */}
				<div
					className="bg-fill-information-weaker absolute top-1/2 left-1/2 aspect-[931/909] min-h-full min-w-full -translate-x-1/2 -translate-y-1/2"
					style={{
						maskImage: `url(${globeUrl})`,
						WebkitMaskImage: `url(${globeUrl})`,
						maskSize: 'cover',
						WebkitMaskSize: 'cover',
						maskRepeat: 'no-repeat',
						WebkitMaskRepeat: 'no-repeat',
						maskPosition: 'center',
						WebkitMaskPosition: 'center',
					}}
				/>
			</div>

			<div className="relative z-10 container pt-6 md:pt-[44px] lg:pt-[60px]">
				<div className="mt-3 space-y-6">
					<TitleAndTagline />
					<SapCtas />
				</div>

				{topImpactStories.length > 0 && <TopImpactStoriesDesktop />}
			</div>

			{topImpactStories.length > 0 && (
				<TopImpactStoriesMobileProvider>
					<TopImpactStoriesMobile />
				</TopImpactStoriesMobileProvider>
			)}
		</section>
	);
};
